
<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

<div *ngIf="clientInfo$ | async as clientInfo">

    <!--View Profile-->
    <div mat-dialog-content id="profile" *ngIf="(pageMode$ | async) === 'Profile'">
        <div class="modal-form">
            <h2 mat-dialog-title class="jumbotron-heading text-center">Profile</h2>
            <mat-dialog-content class="mat-typography">


                <!--View Contact Information-->
                <div>
                    <div><span class="standOutText5">Contact Information</span>&nbsp;&nbsp;<a (click)="onEditContactInformation()"><b>Edit</b></a></div>
                    <div class="Vert-10"></div>


                    <div class="row">
                        <div class="col-6 label">First Name</div>
                        <div class="col-6 label">Last Name</div>
                        <div class="col-6 value">{{clientInfo.firstName}}</div>
                        <div class="col-6 value">{{clientInfo.lastName}}</div>
                    </div>
                    <div class="Vert-15"></div>
                    <div class="row">
                        <div class="col-6 label">Email</div>
                        <div class="col-6 label">Phone (Cell)</div>
                        <div class="col-6 value" [ngClass]="clientInfo?.email.length > 30 ? 'small-text' : '' " >{{clientInfo.email}}</div>
                        <div class="col-6 value">{{clientInfo.mobilePhone}}</div>
                    </div>

                </div>

                <div class="Vert-25"></div>

                <!-- View Financial Details -->
                <div>
                    <div><span class="standOutText5">Financial Details</span>&nbsp;&nbsp;<a (click)="onEditFinancialDetails()"><b>Edit</b></a></div>
                    <div class="Vert-10"></div>

                    <div class="row">
                        <div class="col-6 label">FICO</div>
                        <div class="col-6 label">DTI</div>
                        <div class="col-6 value">{{clientInfo.fico}}</div>
                        <div class="col-6 value">{{DTI}}</div>
                    </div>
                    <div class="Vert-15"></div>
                    <div class="row">
                        <div class="col-6 label">Monthly Gross Income</div>
                        <div class="col-6 label">Monthly Debt Payments</div>
                        <div class="col-6 value">${{clientInfo.totalIncome | number : '1.0-0'}}</div>
                        <div class="col-6 value">${{clientInfo.totalDebtPayments | number : '1.0-0'}}</div>
                    </div>
                    <div class="Vert-15"></div>
                    <div class="row">
                        <div class="col-6 label">First-Time Homebuyer</div>
                        <div class="col-6 label"></div>
                        <div class="col-6 value"><span *ngIf="clientInfo.firstTimeBuyer">YES</span><span *ngIf="!(clientInfo.firstTimeBuyer)">NO</span></div>
                        <div class="col-6 value"></div>
                    </div>
                </div>



            </mat-dialog-content>

            <mat-dialog-actions class="dialog-actions" align="end">
                <button mat-stroked-button class="btn btn-secondary" (click)="onClose()">
                    Close
                </button>
            </mat-dialog-actions>

        </div>
    </div>

    <!--Edit Contact Information-->
    <div mat-dialog-content id="edit-contact-information" *ngIf="(pageMode$ | async) === 'EditContactInformation'">

        <div class="modal-form">
            <div class="edit">
                <form [formGroup]="contactInfoForm">

                    <div>
                        <div class="standOutText5 text-center">Edit Contact Information</div>
                        <div class="Vert-10"></div>

                        <div class="row">
                            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                                <mat-label>First Name</mat-label>
                                <input type="text" matInput formControlName="firstName" required>
                                <mat-error *ngIf="contactInfoForm.controls.firstName.errors?.required">
                                    First Name is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                                <mat-label>Last Name</mat-label>
                                <input type="text" matInput formControlName="lastName" required>
                                <mat-error *ngIf="contactInfoForm.controls.lastName.errors?.required">
                                    Last Name is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                                <mat-label>Email</mat-label>
                                <input type="text" matInput formControlName="email" required>
                                <mat-error *ngIf="contactInfoForm.controls.email.errors?.required">
                                    Email is required
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                                <mat-label>Phone</mat-label>
                                <input type="text" matInput formControlName="mobilePhone">
                            </mat-form-field>



                        </div>
                    </div>


                </form>
            </div>
        </div>
        <div>
            <mat-dialog-actions class="dialog-actions" align="end">
                <button mat-stroked-button class="btn btn-secondary" (click)="onCancelEdit()">
                    Cancel
                </button>
                <button mat-stroked-button class="btn btn-primary" (click)="OnConfirmSave()" [disabled]="!contactInfoForm.valid">
                    Save
                </button>
            </mat-dialog-actions>
        </div>

    </div>

    <!--Edit Financial Details-->
    <div mat-dialog-content id="edit-financial-details" *ngIf="(pageMode$ | async) === 'EditFinancialDetails'">
        <div class="modal-form">
            <div class="edit">
                <form [formGroup]="financialDetailsForm">

                    <div class="standOutText5 text-center">Edit Financial Details</div>
                    <div class="Vert-10"></div>

                    <div class="row">

                        <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                            <mat-label>Credit Score</mat-label>
                            <input type="text" matInput formControlName="fico" required>
                            <mat-error *ngIf="financialDetailsForm.controls.fico.errors?.required">
                                Credit Score is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                            <mat-label>Monthly Gross Income</mat-label>
                            <input type="text" matInput formControlName="totalIncome" required>
                            <mat-error *ngIf="financialDetailsForm.controls.totalIncome.errors?.required">
                                Monthly Gross Income is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                            <mat-label>Monthly Debt Payments</mat-label>
                            <input type="text" matInput formControlName="totalDebtPayments" required>
                            <mat-error *ngIf="financialDetailsForm.controls.totalDebtPayments.errors?.required">
                                Monthly Debt Payments is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" floatLabel="always" class="col-12 col-lg-6">
                            <mat-label>DTI</mat-label>
                            <input type="text" matInput [value]="DTI">
                        </mat-form-field>

                        <div class="col-lg-12 col-md-12">
                            <p>Are you a first-time homebuyer?</p>
                            <mat-radio-group formControlName="firstTimeBuyer">
                                <mat-radio-button [value]="true">Yes &nbsp; &nbsp;</mat-radio-button>
                                <mat-radio-button [value]="false">No</mat-radio-button>
                            </mat-radio-group>
                        </div>


                    </div>

                </form>
            </div>
        </div>
        <div>
            <mat-dialog-actions class="dialog-actions" align="end">
                <button mat-stroked-button class="btn btn-secondary" (click)="onCancelEdit()">
                    Cancel
                </button>
                <button mat-stroked-button class="btn btn-primary" (click)="OnConfirmSave()" [disabled]="!financialDetailsForm.valid">
                    Save
                </button>
            </mat-dialog-actions>
        </div>
    </div>

</div>
